<template>
  <div>
    <v-card-title class="ml-4 primary--text"
      ><v-btn @click="back" class="ml-n7 primary--text" text>
        <v-icon>mdi-keyboard-backspace</v-icon></v-btn
      >Charts
    </v-card-title>
    <v-row>
      <v-col cols="6">
        <v-card elevation="6" height="500px" width="620" class="ml-3 mt-n3">
          <v-tabs fixed-tabs background-color="white" v-model="tab">
            <v-tab v-for="tabname in tabnames" :key="tabname">
              <v-icon v-if="tabname == 'Expenses'" class="mr-2"
                >mdi-chart-bar</v-icon
              >
              <v-icon v-if="tabname == 'Expense Category'" class="ml-n6 mr-2"
                >mdi-chart-arc</v-icon
              >
              <v-icon
                v-if="tabname == 'Expenses Against Budget'"
                class="ml-n4 mr-1"
                >mdi-chart-line</v-icon
              >

              {{ tabname }}</v-tab
            >
          </v-tabs>
          <v-divider> </v-divider>

          <div v-if="this.tab == 0">
            <v-row class="mt-n3 ml-6">
              <v-col cols="5">
                <v-dialog
                  ref="dialogStart"
                  v-model="modalStart"
                  :return-value.sync="start_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <label class="caption">From</label>
                    <v-text-field
                      solo
                      color="primary"
                      dense
                      v-model="start_date"
                      label="From"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      @click:append="date ? getcal() : getcal()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="start_date"
                    scrollable
                    :max="end_date"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalStart = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogStart.save(start_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="5">
                <v-dialog
                  ref="dialogEnd"
                  v-model="modalEnd"
                  :return-value.sync="end_date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <label class="caption">To</label>
                    <v-text-field
                      solo
                      color="primary"
                      dense
                      v-model="end_date"
                      label="To"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      @click:append="date ? getcal2() : getcal2()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="end_date"
                    scrollable
                    :min="start_date"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalEnd = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogEnd.save(end_date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col lg="1" class="mt-7">
                <v-btn
                  x-small
                  fab
                  dark
                  color="primary"
                  class="elevation-0"
                  @click="barchart()"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <BarChart
              :chartdata="routerLineChartData"
              :options="routerLineChartOptions"
              :width="200"
              :height="300"
              class="ml-3 mt-5 mr-6"
              v-if="renderComponent1"
            />
          </div>

          <div v-if="this.tab == 1">
            <v-row class="mt-3 ml-16">
              <v-col cols="5" class="mt-n2">
                <v-select
                  v-model="userId"
                  label="User Name"
                  :items="getUser"
                  dense
                  solo
                  item-text="user_name"
                  item-value="user_id"
                >
                </v-select>
              </v-col>
              <v-col cols="5" class="mt-n2">
                <v-select
                  v-model="depart_id"
                  label="Department Name"
                  :items="DepartId"
                  dense
                  solo
                  item-text="department_name"
                  item-value="department_id"
                >
                </v-select>
              </v-col>
              <v-col cols="5">
                <v-dialog
                  ref="dialogStart1"
                  v-model="modalStart1"
                  :return-value.sync="start_date1"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      solo
                      color="primary"
                      dense
                      v-model="start_date1"
                      label="From"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      @click:append="date ? getcal1() : getcal1()"
                      class="mt-n7"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="start_date1"
                    scrollable
                    :max="end_date"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalStart1 = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogStart1.save(start_date1)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="5">
                <v-dialog
                  ref="dialogEnd1"
                  v-model="modalEnd1"
                  :return-value.sync="end_date1"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      solo
                      color="primary"
                      dense
                      v-model="end_date1"
                      label="To"
                      append-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      @click:append="date ? getcalnew() : getcalnew()"
                      class="mt-n7"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="end_date1"
                    scrollable
                    :min="start_date1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modalEnd1 = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialogEnd1.save(end_date1)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="2" class="mt-n6">
                <v-btn
                  x-small
                  fab
                  dark
                  color="primary"
                  class="elevation-0"
                  @click="linechart()"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <PolarArea
              :chartdata="routerLineChartDataNew"
              :options="routerLineChartOptionsLine"
              :width="200"
              :height="300"
              class="ml-2"
              v-if="renderComponent2"
            />
          </div>
        </v-card>
      </v-col>

      <v-col cols="6" v-if="this.tab == 0">
        <v-card elevation="4" height="auto" width="620" class="ml-0 mt-n3">
          <v-data-table
            v-if="this.tab == 0"
            fixed-header
            :headers="headers2"
            :items="chart_data"
            dense
            hide-default-footer
            flat
          >
            <template v-slot:[`item.sl_no`]="{ item }">
              <span class="caption">{{ chart_data.indexOf(item) + 1 }}</span>
            </template>
            <template v-slot:[`item.total_expense`]="{ item }">
              <b>{{ item.total_expense }}</b>
            </template>
            <template v-slot:[`item.corp_balance`]="{ item }">
              <b>{{ item.corp_balance }}</b>
            </template>
            <template v-slot:[`item.card_bal`]="{ item }">
              <b>{{ item.card_bal }}</b>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col cols="6" v-if="this.tab == 1">
        <v-card elevation="4" height="auto" width="620" class="ml-0 mt-n3">
          <v-data-table
            v-if="this.tab == 1"
            fixed-header
            :headers="headers3"
            :items="chart_dataNew"
            dense
            hide-default-footer
            flat
          >
            <template v-slot:[`item.sl_no`]="{ item }">
              <span class="caption">{{ chart_dataNew.indexOf(item) + 1 }}</span>
            </template>
            <template v-slot:[`item.overall_expense`]="{ item }">
              <b>{{ item.overall_expense }}</b>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import BarChart from "@/components/Charts/BarChart.js";
import PolarArea from "@/components/Charts/PolarArea.js";

import { apiCall } from "@/Views/APICALL/APIcall.js";
import moment from "moment";

export default {
  components: {
    BarChart,
    PolarArea,
  },
  //
  data: () => ({
    getUser: [],
    DepartId: [],
    deptId: "",
    UserId: "",
    depart_id: "",
    userId: "",
    renderComponent1: true,
    renderComponent2: true,
    start_date: null,
    end_date: null,
    start_date1: null,
    end_date1: null,
    modalEnd: false,
    modalEnd1: false,
    modalStart: false,
    modalStart1: false,
    tabnames: ["Expenses", "Expense Category", "Expenses Against Budget"],
    tab: 0,
    clickHandler: null,

    routerLineChartData: {
      labels: [],
      datasets: [
        {
          data: [],
          label: "Total Expense ",
          barThickness: 50,

          backgroundColor: "#2E4152",
          fill: false,
        },
        {
          data: [],
          label: "Corp Balance",
          barThickness: 50,

          backgroundColor: "#A87008",
          fill: false,
        },
        {
          data: [],
          label: "Card Balance ",
          barThickness: 50,

          backgroundColor: "#616161",
          fill: false,
        },
      ],
    },
    routerLineChartOptions: {
      scales: {
        yAxes: [
          {
            gridLines: {
              color: "rgba(0, 0, 0, 0)",
            },
          },
        ],
      },

      responsive: true,
      maintainAspectRatio: false,
    },

    chart_data: [],

    routerLineChartDataNew: {
      labels: [],
      datasets: [
        {
          data: [],
          label: "Overall Expense ",
          lineThickness: 350,
          backgroundColor: [
            "rgb(33, 47, 61)",
            "rgb(211, 84, 0)",
            "rgb(75, 192, 192)",
            "rgb(255, 205, 86)",
            "rgb(201, 203, 207)",
            "rgb(54, 162, 235)",
          ],
          // backgroundColor: " #F4511E ",
          fill: false,
        },
      ],
    },
    routerLineChartOptionsLine: {
      scales: {
        // yAxes: [
        //   {
        //     gridLines: {
        //       color: "rgba(0, 0, 0, 0)",
        //     },
        //   },
        // ],
      },
      layout: {
        padding: 20,
      },
      responsive: true,
      maintainAspectRatio: false,
    },

    chart_dataNew: [],
    headers2: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
        width: "1px",
      },
      {
        text: "User Name",
        value: "user_name",
        align: "start",
        width: "1px",

        sortable: false,
      },
      {
        text: "Total Expense",
        value: "total_expense",
        width: "1px",
        sortable: false,
      },
      {
        text: "Txn Date",
        value: "txn_date",
        width: "1px",

        sortable: false,
      },
      {
        text: "Corp Balance",
        value: "corp_balance",
        width: "1px",

        sortable: false,
      },

      {
        text: " Card Balance",
        value: "card_bal",
        align: "start",

        sortable: false,
        width: "1px",
      },
    ],
    headers3: [
      {
        text: "SL NO",
        value: "sl_no",
        align: "start",
        sortable: false,
        width: "1px",
      },
      {
        text: "User Name",
        value: "user_name",
        align: "start",
        width: "1px",

        sortable: false,
      },
      {
        text: "Category Name ",
        value: "cat_name",
        width: "1px",

        sortable: false,
      },
      {
        text: "Overall Expense",
        value: "overall_expense",
        width: "1px",
        sortable: false,
      },
    ],

    optionsgraph: {
      fill: false,
      responsive: true,

      legend: {
        labels: {
          usePointStyle: true,
        },
      },
      title: {
        display: true,
        maintainAspectRatio: false,
        text: "Overall Expense by category",
        fontSize: 16,
        fontColor: "#6b7280",
      },
      tooltips: {
        backgroundColor: "#000000",
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: false,
            },
          },
        ],
      },
    },
  }),
  watch: {
    chart_data(val) {
      if (val != []) {
        this.forceRerender1();
      }
    },
    chart_dataNew(val) {
      if (val != []) {
        this.forceRerender2();
      }
    },
  },

  mounted() {
    this.start_date = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.end_date = new Date().toISOString().substr(0, 10);
    this.start_date1 = moment().subtract(1, "months").format("YYYY-MM-DD");
    this.end_date1 = new Date().toISOString().substr(0, 10);
  },
  created() {
    this.getusers();
    this.getdepart();
  },
  methods: {
    forceRerender1() {
      this.renderComponent1 = false;
      process.nextTick(() => {
        this.renderComponent1 = true;
      });
    },
    forceRerender2() {
      this.renderComponent2 = false;
      process.nextTick(() => {
        this.renderComponent2 = true;
      });
    },
    back() {
      this.$router.push("/Dashboard");
    },
    async getusers() {
      // alert(20);
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETAPPUSER",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.data != null || responseData.data.data != "") {
        this.getUser = responseData.data.data;
      }
      // console.log("user",this.getUser)
      for (let i = 0; i < this.getUser.length; i++) {
        this.UserId = this.getUser[i].user_id;
        // console.log("userid",this.UserId)
      }
    },
    async getdepart() {
      // alert(20);
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETDEP",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.data != null || responseData.data.data != "") {
        this.DepartId = responseData.data.data;
      }
      //  console.log("Depart",this.DepartId);
      for (let i = 0; i < this.DepartId.length; i++) {
        this.deptId = this.DepartId[i].department_id;
        //  console.log("deptId",this.deptId)
      }
    },
    async barchart() {
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "EXCHARTS",
          corp_id: this.$store.getters.get_corpid,
          from_date: this.start_date == "" ? null : this.start_date,
          to_date: this.end_date == "" ? null : this.end_date,
        },
      };
      this.overlay = false;
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.chart_data = responseData.data.data;
        }
      } else {
        this.chart_data = [];
        this.overlay = false;
      }

      var chartdataitems = [];
      var chartdataitems0 = [];
      var chartdataitems1 = [];

      var chartlabels = [];

      for (let i = 0; i < this.chart_data.length; i++) {
        chartdataitems.push(Number(this.chart_data[i].total_expense));
        chartdataitems0.push(Number(this.chart_data[i].corp_balance));
        chartdataitems1.push(Number(this.chart_data[i].card_bal));

        chartlabels.push(this.chart_data[i].user_name);
      }
      this.routerLineChartData.datasets[0].data = chartdataitems;

      this.routerLineChartData.datasets[1].data = chartdataitems0;
      this.routerLineChartData.datasets[2].data = chartdataitems1;

      this.routerLineChartData.labels = chartlabels;
    },
    async linechart() {
      var inputData = {
        method_name: "CHARTS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "EXCATCHART",
          corp_id: this.$store.getters.get_corpid,
          from_date: this.start_date1 == "" ? null : this.start_date1,
          to_date: this.end_date1 == "" ? null : this.end_date1,
          user_id: this.userId,
          department_id: this.depart_id,
        },
      };
      this.overlay = false;
      var responseData = await apiCall(inputData);
      // console.log("response",responseData.data.data)
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.chart_dataNew = responseData.data.data;
        }
      } else {
        this.chart_dataNew = [];
        this.overlay = false;
      }

      var chartdataitemsNew = [];
      var chartlabelsLine = [];
      for (let i = 0; i < this.chart_dataNew.length; i++) {
        chartdataitemsNew.push(this.chart_dataNew[i].overall_expense);

        chartlabelsLine.push(this.chart_dataNew[i].cat_name);
      }
      this.routerLineChartDataNew.datasets[0].data = chartdataitemsNew;
      this.routerLineChartDataNew.labels = chartlabelsLine;
    },
    getcal() {
      this.modalStart = true;
    },
    getcal1() {
      this.modalStart1 = true;
    },
    getcal2() {
      this.modalEnd = true;
    },
    getcalnew() {
      this.modalEnd1 = true;
    },
  },
};
</script>
